/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpindicativeorder_Modal_Greaterthanzero5Inputs */

const en_coinvestments_gpindicativeorder_modal_greaterthanzero5 = /** @type {(inputs: Coinvestments_Gpindicativeorder_Modal_Greaterthanzero5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicative order must be greater than zero`)
};

/**
* | output |
* | --- |
* | "Indicative order must be greater than zero" |
*
* @param {Coinvestments_Gpindicativeorder_Modal_Greaterthanzero5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpindicativeorder_modal_greaterthanzero5 = /** @type {((inputs?: Coinvestments_Gpindicativeorder_Modal_Greaterthanzero5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpindicativeorder_Modal_Greaterthanzero5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpindicativeorder_modal_greaterthanzero5(inputs)
});
export { coinvestments_gpindicativeorder_modal_greaterthanzero5 as "coInvestments_gpIndicativeOrder_modal_greaterThanZero" }